import React, { Component } from 'react';
import './ServiceHeader.css';

class ServiceHeader extends Component {
  render() {
    return (
      <div className="ServiceHeader">
        <div className="background">
          <div className="contents">
            <span className="desc">서비스 이용약관</span>
            <span className="title">LEMONCAKE</span>
          </div>
        </div>
      </div>
    );
  }
}

export default ServiceHeader;